import { useSelector } from "react-redux";
import { StationHeader } from "../../organism/Header";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import BottomTabs from "../../organism/BottomTabs";
// import { isMobile } from "../../../utilities/deviceUtilities";
import { encrypt } from "../../../utilities/tokenizer";

function Layout() {
    const { worldReducer } = useSelector((state) => state);
    const params=useParams();
    const location= useLocation();
    const navigate=useNavigate();
    let childcode = "";
    let childName = worldReducer?.childList[0]?.childFirstName;

    if(window.location.pathname.includes("/pastSponsoredChild")){
        if(worldReducer?.childList?.length > 0){
            childcode = worldReducer?.childList[0]?.childCode;
        }else{
            childcode = params?.pastchildcode;
        }
    }else if(worldReducer?.childList?.length > 0){
        if(location?.state?.navigateFrom == "home"){
            childcode = encrypt(worldReducer?.childList[0]?.childCode);
        }else{
            childcode = (params?.childcode && params?.childCode !== "undefined") ? params?.childcode : location?.state?.childcode || localStorage.getItem("childcode");
        }
     }else{
        childcode = (params?.childcode && params?.childCode !== "undefined") ? params?.childcode : location?.state?.childcode || localStorage.getItem("childcode");
    }
    localStorage.setItem("childcode", childcode)
    const navToSendAGift=()=>{
        navigate(`/sendAGift/${params?.childcode ? params?.childcode : location?.state?.childcodex}`,{state:{navigateFrom:"station"}})
    } 
    const handleConnectClick = () =>{
        navigate(`/connect/${params?.childcode ? params?.childcode : location?.state?.childcode}`,{state:{navigateFrom:"station"}})
    }

    return ( 
        <>
        <StationHeader
              page="childstation" 
              totalSponsoredChild={worldReducer?.childList?.length} 
              childcode={childcode}
              childName={childName}
              back="-1"
              searchChildData={worldReducer?.childList}
              handleConnectClick={handleConnectClick}
              handleGiftClick={navToSendAGift}
              navigateFrom={location?.state?.navigateFrom}
            />
           
            {(window.location.pathname.includes("/childprofile") 
                || window.location.pathname.includes("/childcommunity")
                || window.location.pathname.includes("/station")
                || window.location.pathname.includes("/myaccount")
                || window.location.pathname.includes("/sponsorships")
                || window.location.pathname.includes("/security")
                || window.location.pathname.includes("/notification")
                || window.location.pathname.includes("/donations")
                || window.location.pathname.includes("/pastSponsoredChild")
                )
                && location?.state?.navigateFrom != "home" && 
                        <BottomTabs 
                        selectedChild={params?.childcode ? params?.childcode : location?.state?.childcode} activeChildList={worldReducer?.childList}
                        station/>}

            {(window.location.pathname.includes("/communityhomeview") 
                ||window.location.pathname.includes("/getHelp") 
                ||window.location.pathname.includes("/sendAGift") 
                ||window.location.pathname.includes("/newsandstories")
                ||window.location.pathname.includes("/connect")
            )&& 
                <BottomTabs 
                    community= {window.location.pathname.includes("/communityhomeview")}
                    communityHome = {window.location.pathname.includes("/communityhomeview") }
                    gift={window.location.pathname.includes("/getHelp") || window.location.pathname.includes("/sendAGift") }
                    help={window.location.pathname.includes("/getHelp") }
                    station={window.location.pathname.includes("/newsandstories")}
                    newsfeed={window.location.pathname.includes("/newsandstories") || window.location.pathname.includes("/connect")}
                    connect={window.location.pathname.includes("/connect") }
                    selectedChild={params?.childcode ? params?.childcode : location?.state?.childcode}
                    handleConnectClick={window.location.pathname.includes("/communityhomeview") && handleConnectClick}
                    handleGetHelpClick={window.location.pathname.includes("/communityhomeview")  && navToSendAGift}
                    searchChildData={worldReducer?.childList}/>
            }
            
        </>
    );
}

export default Layout;